module.exports = __webpack_public_path__ + "static/media/bg_dot_left.1ce2ccca.svg";